import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axiosInstance from 'utils/axios';
import FormatDate from 'utils/formatDate';
import isValidDate from 'utils/isValidDate';
import submissionBg from './submission.webp';

const AbstractSubmission = () => {
    const theme = useTheme();
    const [endPeriod, setEndPeriod] = useState();
    const [isOpen, setIsOpen] = useState(true);

    const getData = async () => {
        await axiosInstance
            .get('api/system-parameters/name/end_off_submission_period')
            .then((res) => {
                setEndPeriod(res.data.value);
                setIsOpen(isValidDate(res.data.value));
            })
            .catch((err) => console.log(err));
    };

    useEffect(() => {
        getData();
    }, []);

    return (
        <Box
            sx={{
                position: 'relative',
                overflow: 'hidden',
                py: { xs: 6, md: 10 },
                background: `radial-gradient(ellipse at 15% 0%, ${theme.palette.primary.main}10 0%, transparent 40%), radial-gradient(ellipse at 85% 0%, ${theme.palette.secondary.main}10 0%, transparent 45%), linear-gradient(135deg, ${theme.palette.grey[50]} 0%, white 60%, ${theme.palette.primary.main}08 100%)`,
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: -80,
                    right: -80,
                    width: 240,
                    height: 240,
                    borderRadius: '50%',
                    background: `linear-gradient(45deg, ${theme.palette.primary.main}12, ${theme.palette.secondary.main}12)`,
                    zIndex: 0,
                }}
            />

            <Box
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    display: 'flex',
                    justifyContent: 'center',
                }}
            >
                <Card
                    sx={{
                        position: 'relative',
                        maxWidth: 960,
                        width: '100%',
                        borderRadius: 4,
                        background: `linear-gradient(135deg, ${theme.palette.primary.main}10 0%, ${theme.palette.secondary.main}08 100%)`,
                        border: `1px solid ${theme.palette.primary.main}20`,
                        boxShadow: '0 16px 50px rgba(0,0,0,0.12)',
                        '&::before': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundImage: `url(${submissionBg})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            opacity: 0.2,
                            zIndex: 1,
                        },
                        '& > *': {
                            position: 'relative',
                            zIndex: 2,
                        },
                    }}
                >
                    <CardContent sx={{ p: { xs: 3, md: 5 } }}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                mb: 2,
                            }}
                        >
                            <ArticleOutlinedIcon
                                sx={{
                                    fontSize: 36,
                                    color: theme.palette.primary.main,
                                    mr: 2,
                                }}
                            />
                            <Typography
                                variant="h5"
                                sx={{ fontWeight: 800, mr: 1 }}
                            >
                                Abstract Submission for INAACC 2026 Semarang
                            </Typography>
                            <Chip
                                label={isOpen ? 'Open Now' : 'Closed'}
                                color={isOpen ? 'success' : 'default'}
                                size="small"
                                fontWeight={700}
                            />
                        </Box>

                        <Divider sx={{ mt: 3, mb: 2 }} />

                        <Typography variant="h6" fontWeight={500}>
                            Call For Submissions
                        </Typography>
                        <Typography>
                            Send in your best Cases and Abstracts by{' '}
                            {endPeriod &&
                                FormatDate(endPeriod, 'MMMM do, yyyy HH:mm')}
                        </Typography>

                        <Stack
                            direction="row"
                            spacing={1}
                            flexWrap="wrap"
                            sx={{ my: 2 }}
                        >
                            <Chip
                                size="small"
                                color="primary"
                                label="Oral"
                                sx={{ fontWeight: 700 }}
                            />
                            <Chip
                                size="small"
                                variant="outlined"
                                label="Poster"
                                color="secondary"
                            />
                            <Chip
                                size="small"
                                variant="outlined"
                                label="Case Report"
                                color="secondary"
                            />
                        </Stack>

                        <Stack
                            direction={{ xs: 'column', sm: 'row' }}
                            spacing={1.5}
                            justifyContent="center"
                        >
                            <Button
                                component={Link}
                                to={'/abstract-submission'}
                                variant="contained"
                                color="primary"
                                size="large"
                                sx={{
                                    flex: 1,
                                    maxWidth: 280,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 700,
                                }}
                            >
                                Submit Your Abstract
                            </Button>
                            <Button
                                component={Link}
                                to={
                                    '/assets/Abstract Guideline InaACC 2026.pdf'
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                download
                                variant="outlined"
                                color="secondary"
                                size="large"
                                sx={{
                                    flex: 1,
                                    maxWidth: 280,
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 700,
                                }}
                            >
                                Download Guidelines
                            </Button>
                        </Stack>
                    </CardContent>
                </Card>
            </Box>
        </Box>
    );
};

export default AbstractSubmission;
